import React, { useState } from "react";
import { SliderPanel } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoiceDollar,
  faPenSquare,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { Button, InputGroup } from "react-bootstrap";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useDeepEffect } from "../../../abstracts";
import InvestmentCardRight from "./InvestmentCardRight";
import InvestmentCardLeft from "./InvestmentCardLeft";
import { isEmpty } from "lodash";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";

const ExcludedInvestments = (props) => {
  const {
    investmentsData,
    setInvestmentsData,
    totalInvestment,
    setTotalInvestment,
    excludedInvestment,
    setExcludedInvestment,
    finalExcludedInvestment,
    setFinalExcludedInvestment,
    initialSavedInvestments,
    setInitialSavedInvestments,
    isEdit,
    isSave,
  } = props;
  const [investmentSliderOpen, setInvestmentSliderOpen] = useState(false);

  useDeepEffect(() => {
    setTotalInvestment(investmentsData.filter((x) => x.excluded == false));
  }, [investmentsData]);
  useDeepEffect(() => {
    setExcludedInvestment(investmentsData.filter((x) => x.excluded == true));
  }, [investmentsData]);
  //const totalInvestment = investmentsData.filter((x) => x.excluded == false);
  //const excludedInvestment = investmentsData.filter((x) => x.excluded == true);
  const [searchTotalInvestments, setSearchTotalInvestments] = useState("");
  const [searchExcludedInvestments, setSearchExcludedInvestments] = useState(
    ""
  );

  //FOR REMOVING ONE INVESTMENT
  const removeInvestment = (investmentId) => {
    setInvestmentsData(
      investmentsData.map((e) => {
        if (e.investmentId == investmentId)
          return {
            ...e,
            excluded: false,
          };
        else return e;
      })
    );
  };

  //FOR REMOVING ONE INVESTMENT
  const removeAllInvestment = () => {
    setInvestmentsData(
      investmentsData.map((e) => {
        return {
          ...e,
          excluded: false,
        };
      })
    );
  };

  //FOR ADDING ONE INVESTMENT
  const addInvestment = (investmentId) => {
    setInvestmentsData(
      investmentsData.map((e) => {
        if (e.investmentId == investmentId)
          return {
            ...e,
            excluded: true,
          };
        else return e;
      })
    );
  };

  //FOR ADDING ALL INVESTMENT
  const addAllInvestment = () => {
    setInvestmentsData(
      investmentsData.map((e) => {
        return {
          ...e,
          excluded: true,
        };
      })
    );
  };

  //FOR DELETING SAVED INVESTMENT
  const deleteInvestmentExclusion = () => {
    setInvestmentsData(
      investmentsData.map((e) => {
        return {
          ...e,
          excluded: false,
        };
      })
    );
  };

  //FOR SEARCHING LEFT SIDE INVESTMENT
  useDeepEffect(() => {
    if (searchTotalInvestments !== "") {
      setTotalInvestment(
        totalInvestment.filter((item) => {
          return item.name
            .toLowerCase()
            .includes(searchTotalInvestments.toLowerCase());
          //||
          //team.rkPlanNumber.includes(searchAddedPlans)
        })
      );
    } else {
      setTotalInvestment(investmentsData.filter((x) => x.excluded == false));
    }
  }, [searchTotalInvestments]);

  //FOR SEARCHING RIGHT SIDE INVESTMENT
  useDeepEffect(() => {
    if (searchExcludedInvestments !== "") {
      setExcludedInvestment(
        excludedInvestment.filter((item) => {
          return item.name
            .toLowerCase()
            .includes(searchExcludedInvestments.toLowerCase());
          //||
          //team.rkPlanNumber.includes(searchAddedPlans)
        })
      );
    } else {
      setExcludedInvestment(investmentsData.filter((x) => x.excluded == true));
    }
  }, [searchExcludedInvestments]);

  const addExcludedInvestment = () => {
    const results = excludedInvestment.filter(
      ({ investmentId: x }) =>
        !initialSavedInvestments.some(({ investmentId: y }) => x === y)
    );
    if (results.length > 0) {
      setFinalExcludedInvestment({ ...initialSavedInvestments, ...results });
      setInvestmentSliderOpen(false);
    }
  };
  const cancelExcludedInvestment = () => {
    const results = excludedInvestment.filter(
      ({ investmentId: x }) =>
        !initialSavedInvestments.some(({ investmentId: y }) => x === y)
    );
    if (results.length > 0) {
      //setFinalExcludedInvestment(results)
      setInvestmentSliderOpen(false);
    } else {
      setInvestmentSliderOpen(false);
    }
  };
  const getCount = () => {
    if (!isEmpty(initialSavedInvestments) && isEmpty(finalExcludedInvestment)) {
      return initialSavedInvestments.length;
    } else if (
      isEmpty(initialSavedInvestments) &&
      !isEmpty(finalExcludedInvestment)
    ) {
      return investmentsData.filter((x) => x.excluded).length;
    } else {
      return investmentsData.filter((x) => x.excluded).length;
    }
  };

  return (
    <>
      <div
        className="addedPlans-card-font"
        style={{
          marginBottom: "20px",
        }}
      >
        Exclude Investment(s)
      </div>

      {getCount() > 0 ? (
        <div
          className="d-flex flex-col"
          style={{
            border: "1px solid #D8D8DC",
            borderRadius: "5px",
            width: "65%",
            //padding: "15px",
            marginBottom: "20px",
          }}
        >
          <div
            className="ft-14 fw-400 p-1"
            style={{ backgroundColor: "#bdbdbd" }}
          >
            <FontAwesomeIcon className="ft-14 mr-1" icon={faInfoCircle} />
            Fee will not be deducted from the excluded & restricted investments
            at the time of Fee Run.
          </div>
          <div className="d-flex flex-row" style={{ padding: "15px" }}>
            <div className="d-flex flex-col" style={{ width: "80%" }}>
              <span
                style={{
                  color: "#919191",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "7px",
                }}
              >
                Investments added
              </span>
              <div
                style={{
                  color: "#363638",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                <FontAwesomeIcon className="mr-2" icon={faFileInvoiceDollar} />
                {getCount()}
              </div>
            </div>
            <div
              className="d-flex flex-row"
              style={{ width: "20%", marginTop: "15px" }}
            >
              <FontAwesomeIcon
                className="primary-small"
                onClick={() => {
                  !isEdit && setInvestmentSliderOpen(true);
                }}
                style={{
                  cursor: isEdit ? "not-allowed" : "default",
                  fontSize: "26px",
                  fontWeight: "300",
                  marginRight: "40px",
                }}
                icon={faPenSquare}
              />
              <FontAwesomeIcon
                onClick={() => deleteInvestmentExclusion()}
                style={{
                  cursor: "pointer",
                  color: "#C4061A",
                  fontSize: "26px",
                  fontWeight: "300",
                }}
                icon={faTrashAlt}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex flex-col"
          style={{
            border: "1px solid #D8D8DC",
            borderRadius: "5px",
            width: "45%",
            padding: "15px",
            marginBottom: "20px",
          }}
        >
          <span className="addedPlans-card-font span-plans ft-16">
            No Investments added(s) added
          </span>
          <Button
            onClick={() => !isEdit && setInvestmentSliderOpen(true)}
            variant="secondary"
            style={{
              width: "fit-content",
              cursor: isEdit ? "not-allowed" : "default",
            }}
          >
            Add Investments
          </Button>
        </div>
      )}
      <SliderPanel
        isOpen={investmentSliderOpen}
        size="60"
        showCancelButton={true}
        showCancel={false}
        onClose={() => cancelExcludedInvestment()}
        showSave={true}
        onSave={() => addExcludedInvestment()}
        showHeader={true}
        header="Investments information"
        headerClass="slider-title-case"
        backdropClicked={() => {
          setInvestmentSliderOpen(false);
        }}
      >
        <div className="w-100 height-90 d-flex flex-row justify-content-between">
          <div className="Investment-left-side">
            <p>Applicable Investments</p>
            <div className="w-100">
              <div className="flex-search">
                <InputGroup>
                  <InputGroup.Prepend>
                    <div className="searchIconPostion">
                      <i class="fal fa-search" aria-hidden="true"></i>
                    </div>
                  </InputGroup.Prepend>

                  <SearchBar
                    size="md"
                    type="search"
                    placeholder="Search plan group name"
                    className="PadLeftSearch"
                    onChange={
                      (e) => setSearchTotalInvestments(e.target.value)
                      //console.log(e.target.value)
                    }
                  />
                </InputGroup>
              </div>
            </div>
            {/* <div className="d-flex">
                    <div>10 records found</div>
                    <div>Add all</div>
                  </div> */}
            <div className="smallOptions pl-0">
              <div className="small-text">
                {totalInvestment.length} Investments
              </div>
              <div className="small-text mr-2">
                <p
                  className="link primary-small mb-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => addAllInvestment()}
                >
                  Add all
                </p>
              </div>
            </div>
            <div
              className="d-flex flex-row marg-top-20 justify-content-between"
              style={{ paddingLeft: "10px", marginBottom: "10px" }}
            >
              <div className="ft-14 fw-600 headerColor">
                Cusip ID & Investment name
              </div>
              <div className="ft-14 fw-600 headerColor marg-right-42">
                Action
              </div>
            </div>
            <div style={{ height: "60vh", overflowY: "auto" }}>
              {!isEmpty(totalInvestment) ? (
                totalInvestment.map((data) => (
                  <InvestmentCardLeft
                    data={data}
                    addInvestment={addInvestment}
                  />
                ))
              ) : (
                <div className="plan-group-no-plan">
                  <div className="plan-no-plan">No plans added</div>
                  <div className="plan-add-plan">
                    Please add investments here by clicking on the arrow
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="Investment-right-side">
            <p>Excluded Investments</p>
            <div className="w-100">
              <div className="flex-search">
                <InputGroup>
                  <InputGroup.Prepend>
                    <div className="searchIconPostion">
                      <i class="fal fa-search" aria-hidden="true"></i>
                    </div>
                  </InputGroup.Prepend>

                  <SearchBar
                    size="md"
                    type="search"
                    placeholder="Search plan group name"
                    className="PadLeftSearch"
                    onChange={
                      (e) => setSearchExcludedInvestments(e.target.value)
                      //console.log(e.target.value)
                    }
                  />
                </InputGroup>
              </div>
            </div>
            {/* <div className="d-flex">
                    <div>10 records found</div>
                    <div>Add all</div>
                  </div> */}
            <div className="smallOptions pl-0">
              <div className="small-text">
                {excludedInvestment.length} Investments
              </div>
              <div className="small-text mr-2">
                <p
                  className="link primary-small mb-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => removeAllInvestment()}
                >
                  Remove all
                </p>
              </div>
            </div>
            <div
              className="d-flex flex-row marg-top-20 justify-content-between"
              style={{ paddingLeft: "10px", marginBottom: "10px" }}
            >
              <div className="ft-14 fw-600 headerColor">
                Cusip ID & Investment name
              </div>
              <div className="ft-14 fw-600 headerColor marg-right-42">
                Action
              </div>
            </div>
            <div style={{ height: "60vh", overflowY: "auto" }}>
              {!isEmpty(excludedInvestment) ? (
                excludedInvestment.map((data) => (
                  <InvestmentCardRight
                    data={data}
                    removeInvestment={removeInvestment}
                  />
                ))
              ) : (
                <div className="plan-group-no-plan">
                  <div className="plan-no-plan">No plans added</div>
                  <div className="plan-add-plan">
                    Please add investments here by clicking on the arrow
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </SliderPanel>
    </>
  );
};
export default ExcludedInvestments;
